import Axios from '@/Axios'

class ChartLockIssueService {
    async getChartLockIssue(data = {}) {
        return await Axios.get('wms.wms.api.chart_lock_issue.get_chart_lock_issues', {
            params: data,
        })
    }

    async createChartLockIssue(data) {
        return await Axios.post('wms.wms.api.chart_lock_issue.create_chart_lock_issue', data)
    }
    async deleteChartLockIssue(chart_lock_issue) {
        const transformedPayorType = chart_lock_issue.map((item) => ({ name: item }))
        return await Axios.delete('wms.wms.api.chart_lock_issue.delete_chart_lock_issues', { data: { chart_lock_issue: transformedPayorType } })
    }
}

export default new ChartLockIssueService()
